import { TypeInfo } from 'helpers/enums';
import DeliveryInfo from './DeliveryInfo';
import ProductInfo from './ProductInfo';

interface IProps {
    typeInfo: TypeInfo
}

let Request = (props: IProps) => {
    return (
        <>
            <br />
            {props.typeInfo === TypeInfo.Delivery && <DeliveryInfo />}
            {props.typeInfo === TypeInfo.Product && <ProductInfo />}
        </>
    )
}

export default Request;